import { Flex, HStack, Image, Text, VStack, Button, Input, Select } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ProfileConatiner } from '../../../components/LandingPageComponents/styles/SplashStyles';
import { backbtn } from './Icons';
import ImagePlaceholder from '../../../assets/ImagePlaceholder.jpg';
import axios from 'axios';
import { update_profile } from '../../../redux/actions/profileActions';
import { useDispatch, useSelector } from 'react-redux';
import { Backbutton } from 'components/LandingPageComponents/styles/HeaderStyles';
import useGetUserDetails from 'hooks/useGetUserDetail';

const PartnerProfile = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const profileReducer = useSelector((state) => state.profileReducer);

    let title = location.pathname;
    var array = title.split('/');

    const { from } = profileReducer;

    var decoded = useGetUserDetails();
    const details = decoded?.flattenedUser?.attributes;

    useEffect(() => {
        if (from === 'partner') {
            navigate('/dashboard/settings');
        }
    }, [from, navigate]);

    const [partner_information, setPartnerInformation] = useState({
        title: details?.title || '',
        full_name: details?.full_name || '',
        phone: details?.phone || '',
        state: details?.state || '',
        lga: details?.lga || '',
        full_address: details?.full_address || '',
        landmark: details?.landmark || '',
        birthday: details?.birthday || '',
        creation_source: details?.creation_source || '',
        partner_imgage: details?.partner_imgage || '',
    });

    const hiddenFileInput = React.useRef(null);
    const handleClick = (event) => {
        hiddenFileInput.current.click();
    };

    const handleFileUpload = (event) => {
        const formData = new FormData();
        formData.append('file', event.target.files[0]);
        formData.append('upload_preset', 'o5dxfulx');

        axios
            .post('https://api.cloudinary.com/v1_1/tajiri/image/upload', formData)
            .then((response) => {
                setPartnerInformation({
                    ...partner_information,
                    partner_imgage: response?.data?.url,
                });
            });
    };

    const handleProceed = () => {
        const data = {
            partner_information: { ...partner_information },
        };
        let fro = 'partner';

        dispatch(update_profile(data, fro));
    };

    const titleList = ['Mr', 'Mrs', 'Miss', 'Engr', 'Dr'];
    const states = [
        'Abia',
        'Adamawa',
        'Akwa Ibom',
        'Anambra',
        'Bauchi',
        'Bayelsa',
        'Benue',
        'Borno',
        'Cross River',
        'Delta',
        'Ebonyi',
        'Edo',
        'Ekiti',
        'Enugu',
        'FCT - Abuja',
        'Gombe',
        'Imo',
        'Jigawa',
        'Kaduna',
        'Kano',
        'Katsina',
        'Kebbi',
        'Kogi',
        'Kwara',
        'Lagos',
        'Nasarawa',
        'Niger',
        'Ogun',
        'Ondo',
        'Osun',
        'Oyo',
        'Plateau',
        'Rivers',
        'Sokoto',
        'Taraba',
        'Yobe',
        'Zamfara',
    ];

    return (
        <ProfileConatiner>
            <HStack
                justify="space-between"
                alignItems="center"
                display={{ base: 'flex', lg: 'none', sm: 'flex' }}>
                <Backbutton onClick={() => navigate(-1)}>{backbtn}</Backbutton>
                <div className="menuSection">
                    <Text fontSize="18px">
                        {array[array.length - 1] === 'partner' && 'Partner details'}
                    </Text>
                </div>
                <div></div>
            </HStack>

            <Flex w="full" h="full" justify="center" alignItems="center" flexDir="column">
                <VStack mt="30px">
                    <Text textAlign="center" fontSize="14px" mb={{ base: '10px', lg: '5px' }}>
                        Your Agent ID <br />
                        <b>{details?.agent_id || 'TAJ-4626'}</b>
                    </Text>
                    <Image
                        src={partner_information.partner_imgage || ImagePlaceholder}
                        w="64px"
                        h="64px"
                        borderRadius="50%"
                    />
                    <Button
                        bg="#E7E7FF"
                        borderRadius="48px"
                        py="8px"
                        px="16px"
                        h="32px"
                        color="#1b3b5f"
                        fontSize="13px"
                        onClick={handleClick}
                        fontWeight="500"
                        _hover={{ bg: '#' }}>
                        Upload Logo
                    </Button>
                    <Input
                        type="file"
                        ref={hiddenFileInput}
                        onChange={handleFileUpload}
                        style={{ display: 'none' }}
                    />
                </VStack>

                <VStack mt="40px" w="full" justifyContent="space-between" alignItems="self-start">
                    <Flex
                        w="full"
                        justifyContent="space-between"
                        pl="5px"
                        py={{ base: '20px', lg: '10px' }}
                        className="noTop"
                        borderTop="1px solid #f2f4f5">
                        <Text fontSize="16px" color="#090A0A">
                            Title
                        </Text>

                        <Select
                            w="30%"
                            icon="none"
                            textAlign="right"
                            placeholder="Title"
                            variant="unstyled"
                            value={partner_information.title}
                            onChange={(e) => {
                                setPartnerInformation({
                                    ...partner_information,
                                    title: e.target.value,
                                });
                            }}>
                            {titleList.map((state) => (
                                <option key={state} value={state}>
                                    {state}
                                </option>
                            ))}
                        </Select>
                    </Flex>
                    <Flex
                        w="full"
                        justifyContent="space-between"
                        pl="5px"
                        className="noTop"
                        py={{ base: '20px', lg: '10px' }}
                        borderTop="1px solid #f2f4f5">
                        <Text fontSize="16px" color="#090A0A">
                            Full name
                        </Text>
                        <Input
                            w="45%"
                            textAlign="right"
                            type="text"
                            placeholder="enter Full name"
                            variant="unstyled"
                            value={partner_information.full_name}
                            onInput={(e) => {
                                setPartnerInformation({
                                    ...partner_information,
                                    full_name: e.target.value,
                                });
                            }}
                        />
                    </Flex>
                    <Flex
                        w="full"
                        justifyContent="space-between"
                        pl="5px"
                        className="noTop"
                        py={{ base: '20px', lg: '10px' }}
                        borderTop="1px solid #f2f4f5">
                        <Text fontSize="16px" color="#090A0A">
                            Phone number
                        </Text>
                        <Input
                            w="45%"
                            textAlign="right"
                            type="tel"
                            inputMode="tel"
                            placeholder="enter phone number"
                            variant="unstyled"
                            value={partner_information.phone}
                            onInput={(e) => {
                                setPartnerInformation({
                                    ...partner_information,
                                    phone: e.target.value,
                                });
                            }}
                        />
                    </Flex>
                    <Flex
                        w="full"
                        pt="32px"
                        pb="12px"
                        pl="5px"
                        bg="#F7F9FA"
                        className="noTop"
                        justifyContent="space-between">
                        <Text color="#6C7072" fontSize="12px">
                            MORE INFORMATION
                        </Text>
                    </Flex>
                    <Flex
                        w="full"
                        justifyContent="space-between"
                        pl="5px"
                        className="noTop"
                        py={{ base: '20px', lg: '10px' }}
                        borderTop="1px solid #f2f4f5">
                        <Text fontSize="16px" color="#090A0A">
                            State
                        </Text>
                        <Select
                            w="30%"
                            icon="none"
                            textAlign="right"
                            placeholder="Select state"
                            variant="unstyled"
                            value={partner_information.state}
                            onChange={(e) => {
                                setPartnerInformation({
                                    ...partner_information,
                                    state: e.target.value,
                                });
                            }}>
                            {states.map((state) => (
                                <option key={state} value={state}>
                                    {state}
                                </option>
                            ))}
                        </Select>
                    </Flex>
                    <Flex
                        w="full"
                        justifyContent="space-between"
                        pl="5px"
                        className="noTop"
                        py={{ base: '20px', lg: '10px' }}
                        borderTop="1px solid #f2f4f5">
                        <Text fontSize="16px" color="#090A0A">
                            LGA
                        </Text>
                        <Input
                            w="45%"
                            textAlign="right"
                            type="text"
                            placeholder="enter LGA"
                            variant="unstyled"
                            value={partner_information.lga}
                            onInput={(e) => {
                                setPartnerInformation({
                                    ...partner_information,
                                    lga: e.target.value,
                                });
                            }}
                        />
                    </Flex>
                    <Flex
                        w="full"
                        justifyContent="space-between"
                        pl="5px"
                        className="noTop"
                        py={{ base: '20px', lg: '10px' }}
                        borderTop="1px solid #f2f4f5">
                        <Text fontSize="16px" color="#090A0A">
                            Full address
                        </Text>
                        <Input
                            w="45%"
                            textAlign="right"
                            type="text"
                            placeholder="enter address"
                            variant="unstyled"
                            value={partner_information.full_address}
                            onInput={(e) => {
                                setPartnerInformation({
                                    ...partner_information,
                                    full_address: e.target.value,
                                });
                            }}
                        />
                    </Flex>
                    <Flex
                        w="full"
                        justifyContent="space-between"
                        pl="5px"
                        className="noTop"
                        py={{ base: '20px', lg: '10px' }}
                        borderTop="1px solid #f2f4f5">
                        <Text fontSize="16px" color="#090A0A">
                            Landmark
                        </Text>
                        <Input
                            w="45%"
                            textAlign="right"
                            type="text"
                            placeholder="enter landmark"
                            variant="unstyled"
                            value={partner_information.landmark}
                            onInput={(e) => {
                                setPartnerInformation({
                                    ...partner_information,
                                    landmark: e.target.value,
                                });
                            }}
                        />
                    </Flex>

                    <Flex
                        w="full"
                        justifyContent="space-between"
                        pl="5px"
                        className="noTop"
                        py={{ base: '20px', lg: '10px' }}
                        borderTop="1px solid #f2f4f5">
                        <Text fontSize="16px" color="#090A0A">
                            Birthday
                        </Text>
                        <Input
                            w="45%"
                            textAlign="right"
                            type="date"
                            placeholder="MM/DD/YYYY"
                            variant="unstyled"
                            value={partner_information.birthday}
                            onInput={(e) => {
                                setPartnerInformation({
                                    ...partner_information,
                                    birthday: e.target.value,
                                });
                            }}
                            sx={{
                                '::-webkit-calendar-picker-indicator': {
                                    background: 'white',
                                },
                            }}
                        />
                    </Flex>
                    <Flex
                        w="full"
                        justifyContent="space-between"
                        pl="5px"
                        flexDirection="column"
                        className="noTop"
                        py={{ base: '20px', lg: '10px' }}
                        borderTop="1px solid #f2f4f5">
                        <Text fontSize="16px" color="#090A0A">
                            How did you hear about Obana?
                        </Text>
                        <Input
                            w="full"
                            placeholder="type response"
                            textAlign="right"
                            type="text"
                            variant="unstyled"
                            value={partner_information.creation_source}
                            onInput={(e) => {
                                setPartnerInformation({
                                    ...partner_information,
                                    creation_source: e.target.value,
                                });
                            }}
                        />
                    </Flex>
                    <Flex>
                        <Button
                            colorScheme="grey"
                            bg="#1b3b5f"
                            color="white"
                            fontWeight="400"
                            borderRadius="48px"
                            fontSize="14px"
                            onClick={handleProceed}>
                            Proceed
                        </Button>
                    </Flex>
                </VStack>
            </Flex>
        </ProfileConatiner>
    );
};
// const right = (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//             d="M9 18L15 12L9 6"
//             stroke="#090A0A"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );
export default PartnerProfile;
